import React, { useState, useEffect } from "react";
import "./facilities.css";
import CommonHeader from "../Common Header/CommonHeader";

const SchoolTour = (props) => {
  const { mmid, smid } = props;
  const [schoolTourData, setSchoolTourData] = useState(null);

  return (
    <>
      <CommonHeader heading={"School Tour"} />
      <div className="container" style={{ padding: "20px" }}>
        <div className="row mt-4">
          <div className="col-12">
            <div className="embed-responsive embed-responsive-16by9">
              <iframe
                className="embed-responsive-item"
                title="Youtube player"
                sandbox="allow-same-origin allow-forms allow-popups allow-scripts allow-presentation"
                src={`https://youtube.com/embed/xAG86dgbxN4?autoplay=0`}
                allowFullScreen
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SchoolTour;
